//记得在 src\components\lang\zhLoad.js 里面添加对象
const areaCity = {
  regionNo: '大区编码',
  regionName: '大区名称',
  areaNo: '区域编码',
  areaName: '区域名称',
  cityNo: '城市编码',
  cityName: '城市名称',
  activeOffName: '是否有效',
  msg: {}
};
export default areaCity



// WEBPACK FOOTER //
// ./src/page/md/areaCity/lang/areaCity.zh.js